import { useEffect, useState } from 'react';

const TEXT_FILTER_DEBOUNCE_MS = 250;

export function useDebouncedTextFilter(
  committedValue: string | undefined,
  commitValue: (value: string) => void,
): readonly [string, (value: string) => void] {
  const normalizedCommittedValue = committedValue ?? '';
  const [draftValue, setDraftValue] = useState(normalizedCommittedValue);

  useEffect(() => {
    setDraftValue(normalizedCommittedValue);
  }, [normalizedCommittedValue]);

  useEffect(() => {
    if (draftValue === normalizedCommittedValue) return;

    const timeoutId = window.setTimeout(() => {
      commitValue(draftValue);
    }, TEXT_FILTER_DEBOUNCE_MS);

    return () => window.clearTimeout(timeoutId);
  }, [commitValue, draftValue, normalizedCommittedValue]);

  return [draftValue, setDraftValue] as const;
}
